import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AppFilter } from '@app/shared/models';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { WorkFlowService } from '../../services/workflow.service';

interface IAddConfigModalContext {
  title: string;
  extraData?: any;
}

@Component({
  selector: 'app-update-workflow-group',
  templateUrl: './update-workflow-group.component.html',
  styleUrls: ['./update-workflow-group.component.scss'],
})
export class UpdateWorkflowGroupComponent implements OnInit {
  filter: AppFilter;
  activeOptions = [
    {
      optionId: true,
      optionName: 'ACTIVE',
    },
    {
      optionId: false,
      optionName: 'INACTIVE',
    },
  ];
  success;
  error;
  pending;
  workGroupsList: Array<any> = [];

  workForm: FormGroup = new FormGroup({
    workflowId: new FormControl(''),
    workflowType: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
  });
  extraData;

  formSubmitAttempt;

  constructor(
    public modal: SuiModal<IAddConfigModalContext, void, void>,
    private workflowService: WorkFlowService,
    private modalService: SuiModalService,
    private fb: FormBuilder
  ) {
    this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
    this.extraData = modal.context.extraData;

    this.workForm.patchValue({
      workflowId: this.extraData['jpaWorkflowGroupViewPK']['workflowGroupId'],
      workflowType:
        this.extraData['jpaWorkflowGroupViewPK']['workflowType'].toUpperCase(),
      description: this.extraData['workflowGroupDescription'],
      name: this.extraData['workflowGroupName'],
    });
  }

  close() {
    this.success = null;
    this.error = null;
  }

  isFieldValid(field: string) {
    return (
      (!this.workForm.get(field).valid && this.workForm.get(field).touched) ||
      (this.workForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  save() {
    if (this.workForm.valid) {
      this.pending = true;
      this.workflowService
        .updateWorkflow({
          body: this.workForm.value,
        })
        .subscribe(
          (e) => {
            this.pending = false;
            this.success = 'Workflow was update successfully';
            setTimeout(() => {
              this.modal.approve();
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  ngOnInit(): void {}
}

export class UpdateWorkflowGroupModal extends ComponentModalConfig<
  IAddConfigModalContext,
  void,
  void
> {
  constructor(title: string, extraData: any, size: ModalSize = ModalSize.Mini) {
    super(UpdateWorkflowGroupComponent, { title, extraData });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
    this.transition = 'slide left';
  }
}
